(function () {
  angular
    .module('kareo.ui.shared.modules.regex.zip-code-regex', [])
    .constant('ZIP_CODE_REGEX', /^\d{5}(?:[-\s]?\d{4})?$/);
})();
